import { createSlice } from "@reduxjs/toolkit";
import { PermissionDto } from "../../shared/dtos/permission/PermissionDto";
import {
  getInitialListState,
  generateListReducers,
} from "../utils/listFactory";

const permissionSlice = createSlice({
  name: "permission",
  initialState: getInitialListState<PermissionDto>(),
  reducers: { ...generateListReducers<PermissionDto>() },
});

export const permissionActions = permissionSlice.actions;
export default permissionSlice.reducer;
